import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getContrastHexColour } from 'utilities/colours';
import CONSTANTS from 'chat-constants';
import { isSupportOrFeatureToggledOn } from '../../../utilities/featureToggleHelper';

class Tag extends Component {
  render() {
    if (
      this.props.tag.ai_generated &&
      !isSupportOrFeatureToggledOn(CONSTANTS.FEATURES.FEATURE_AI_INSIGHTS)
    ) {
      return null;
    }

    const contrast = this.props.tag.colour
      ? getContrastHexColour(this.props.tag.colour)
      : '#000';
    const style = {
      container: {
        backgroundColor: this.props.tag.colour,
        color: contrast,
      },
      aiGenerated: {
        background: 'linear-gradient(180deg, #3460AD 0%, #CF66D1 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      },
      tagDot: {
        color: this.props.tag.colour,
      },
    };
    return (
      <div className="conversation-tag d-inline-flex align-items-center">
        {this.props.tag.ai_generated ? (
          <i className="tag-icon far fa-sparkles" style={style.aiGenerated}></i>
        ) : (
          <i className="tag-icon fas fa-circle" style={style.tagDot}></i>
        )}
        <span>{this.props.tag.name}</span>
        {this.props.removeTag ? (
          <i
            className="far fa-times"
            style={{ cursor: 'pointer' }}
            onClick={this.props.removeTag}
          ></i>
        ) : null}
      </div>
    );
  }
}

Tag.propTypes = {
  tag: PropTypes.object.isRequired,
  removeTag: PropTypes.func,
};

export default Tag;
